import { useEffect, useState } from 'react';
import { useAuth, useBasic } from 'contexts';
import { getQuizLog, actionLog } from 'services';
import moment from 'moment';
import 'moment/locale/pt-br';

import './style.scss';

moment.locale('pt-br');

type Props = {
  certifield: any[];
  className?: string;
  [key: string]: any;
};

export function ModalPrintCertificate({ certifield, className, ...rest }: Props) {
  const { user } = useAuth();
  const [log, setLog] = useState<any>();

  const loadData = async () => {
    try {
      if (!user) return;
      const data = await getQuizLog('quiz_certificate', user._id);
      console.log('Data from getQuizLog:', data);
      if (data && data.length > 0) {
        setLog(data[0]);
      } else {
        console.error('No data returned from getQuizLog');
      }
    } catch (error) {
      console.error('Error fetching data from getQuizLog:', error);
    }
  };

  useEffect(() => {
    loadData();

    const modalContents = document.getElementsByClassName('modal-content');
    if (modalContents.length > 0) {
      for (let i = 0; i < modalContents.length; i++) {
        modalContents[i].classList.add('modal-content-print');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handlePrint = () => {
    window.print();
    actionLog('imprimir_certificado');
  };

  if (!certifield) return null;

  return (
    <section id="print" className={className}>
      <button onClick={handlePrint} id="btnPrint">
        Imprimir Certificado
      </button>
      <div id="printContent">
        {certifield[0] && certifield[0].image && <img src={certifield[0].image.original.url} alt="" />}
        <p className="nome">{user?.name}</p>
        <p className="cpf">{user?.extra.cpf}</p>
        {certifield[0] && certifield[0].title && (
          <p className="certificacao">
            {certifield[0].title} {certifield[0].cargaHoraria ? ` - ${certifield[0].cargaHoraria}` : ''}
          </p>
        )}

        {certifield[0] && certifield[0].baseLegal && <p className="baseLegal">{certifield[0].baseLegal}</p>}
        <p className="data">{log && moment(log.finished).format('DD/MM/yyyy')}</p>
        <p className="codigo">{log && log._id}</p>
      </div>
    </section>
  );
}
